module.exports = __webpack_public_path__ + "img/plus.563877b2.png";